import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PackageService } from '../services/package.service';
import { Package } from '../system-data/system-data.component';

@Component({
  selector: 'app-package-insert',
  templateUrl: './package-insert.component.html',
  styleUrls: ['./package-insert.component.css']
})
export class PackageInsertComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PackageInsertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Package, public snackBar: MatSnackBar, public packageService: PackageService) {
    this.selectedIndicators = data.selIndicators;
    this.indicatorIds = data.indicatorIds;
    if (data.product_id != 0) {
      this.getIndicators(data.packageProds);
    }
  }

  ngOnInit() {
  }


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredIndicators: Observable<string[]>;
  selectedIndicators: string[] = [];
  allIndicators: any = [];
  indicatorIds: any;

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;



  remove(fruit): void {
    const index = this.selectedIndicators.indexOf(fruit);
    const indexId = this.indicatorIds.indexOf(fruit.id);
    this.allIndicators.push(fruit);
    this.filteredIndicators = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allIndicators.slice())
    );

    if (index >= 0) {
      this.selectedIndicators.splice(index, 1);
      this.indicatorIds.splice(indexId,1);
    }
    console.log(fruit)
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    var index = this.allIndicators.indexOf(event.option.viewValue);
    if(this.indicatorIds != undefined){
      this.indicatorIds.push(event.option.value.id);
    }else{
      this.indicatorIds = [event.option.value.id];
    }
    if (index !== -1) {
      this.allIndicators.splice(index, 1);
    }
    console.log(event.option);
    this.selectedIndicators.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  private _filter(value): string[] {
    const filterValue = value.name.toLowerCase();

    return this.allIndicators.filter(fruit => console.log(fruit));
  }


  getIndicators(event) {
    this.packageService.getIndicators(event).subscribe(data => {

      this.allIndicators = data;
      data.forEach(element => {
        var index = this.selectedIndicators.indexOf(element);
        if (index !== -1) {
          this.allIndicators.splice(index, 1);
        }
      });

      this.filteredIndicators = this.fruitCtrl.valueChanges.pipe(
        startWith(null),
        map((fruit: string | null) => fruit ? this._filter(fruit) : this.allIndicators.slice())
      );
    })
    return this.allIndicators;
  }

  submit(form) {
    if (this.selectedIndicators.length > 0) {
      console.log(this.indicatorIds);
      var data = {
        indicators: this.indicatorIds,
        products: form.products,
        price: form.price,
        name: form.name,
      }

      console.log(data);
      if (form.package_id == 0) {

        this.packageService.savePackage(data).subscribe(data1 => {
          this.closeModal();
        });
      } else {
        this.packageService.updatePackage(data, form.package_id).subscribe(data1 => {
          this.closeModal();
        });
      }
    } else {
      this.openSnackBar('Изберете показатели към даден пакет', null);

    }


  }

  displayFn(user?: Package): string | undefined {
    return user ? user.name : undefined;
  }

  closeModal() {
    this.dialogRef.close();

  }

}
